"use strict";

import jQuery from 'jquery';

/**
 * Control zum Ändern des Kartenmaßstabs.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCMapScaleSwitcher = function(options)
{
	gc.gis.control.GCAbstractMapControl.call(this, options);

	this._scale_list = options.scales;
	this._allow_user_defined_scale = options.userDefinedScale;
	this._restrict_user_defined_scale = options.restrictUserDefinedScale;

	if (this._scale_list && this._scale_list.length > 0)
	{
		this._scale_list.sort(function(a, b){
			return a.value - b.value;
		});
	}
};
gc.gis.control.GCMapScaleSwitcher.prototype = Object.create( gc.gis.control.GCAbstractMapControl.prototype );

/**
 * @inheritdoc
 */
gc.gis.control.GCMapScaleSwitcher.prototype.init = function()
{
	var self = this;

	this._element = this._render();

	this.updateList();

	this._map.on(gc.gis.map.GCMapEvent.SCALE_CHANGED, this, function(evt) {
		self.updateValue();
	});
};

/**
 * Rendert das Control.
 *
 * @protected
 * @return {jQuery} Container-Element
 */
gc.gis.control.GCMapScaleSwitcher.prototype._render = function()
{
	var self = this;

	if(!this._element)
	{
		this._element = jQuery('<div>', {
			'class': 'gc-map-control gc-map-control-scale-switcher' +(this._className ? ' ' + this._className : '')
		});
		if(this._id)
		{
			this._element.attr('id', this._id.replace('#', '') );
		}
	}
	else
	{
		this._element.children().remove();
	}

	// Formularelemente erstellen
	this._element_label = jQuery('<label>', {
		'class': 'form-group',
		text: ' '
	});
	var element_label_text = jQuery('<span>', {
		'class': 'gc-label-text control-label gc-hidden-xs gc-hidden-sm gc-hidden-md-expanded',
		text: 'Maßstab:'
	});

	this._control = new gc.gis.widget.GCScaleSelector({
		scales: this._scale_list,
		direction: 'up',
		userdefinedScale: self._allow_user_defined_scale,
		inputClassName: 'gc-sm-max-width-6em gc-xs-max-width-6em',
		change: function(scale) {
			self.setValue(scale)
		}
	});

	if (this._restrict_user_defined_scale)
	{
		this._control.setScaleBounds(this._scale_list[0].value, this._scale_list[this._scale_list.length - 1].value);
	}

	this._element_label.prepend(element_label_text).append(this._control.getElement());
	this._element.append(this._element_label);

	return this._element;
};

/**
 * Setzt den Kartenmaßstabs der zugeordneten Karteninstanz.
 *
 * @public
 * @param {number} value Maßstabszahl
 */
gc.gis.control.GCMapScaleSwitcher.prototype.setValue = function(value)
{
	try
	{
		this._map.setScale(value);
		this._control.setScale(value);
	}
	catch( err )
	{
		gc.gis.iface.log.error(this, err);
	}
};

gc.gis.control.GCMapScaleSwitcher.prototype.updateList = function()
{
	// Liste befüllen
	this._control.setScales(this._scale_list);

	// ggf. Grenzen definieren
	if (this._restrict_user_defined_scale)
	{
		this._control.setScaleBounds(this._scale_list[0].value, this._scale_list[this._scale_list.length - 1].value);
	}

	// Initialen Wert setzen
	this.updateValue();
};

/**
 * Aktualisiert den Inhalt des Controls.
 *
 * @public
 * @see gc.gis.map.GCMapView#getScale
 */
gc.gis.control.GCMapScaleSwitcher.prototype.updateValue = function()
{
	this._control.setScale(this._map.getScale());
};
